module.exports = __webpack_public_path__ + "images/backgrounds/canyon/large.ee79179217e377e332d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/canyon/large.jpg
// module id = dPH5
// module chunks = 1